<template>
    <div class="container">
        <homeHead/>
        <div class="home-page">
            <!--轮播图 + 新闻资讯-->
            <div class="top-row">
                <!--轮播图-->
                <div class="banner-box">
                    <el-carousel :interval="4000" arrow="hover" height="100%" v-if="bannerList.length>0">
                        <el-carousel-item v-for="item in bannerList" :key="item.bannerId">
                            <img class="banner-img" :src="item.bannerUrl" alt="" @click="viewBanner(item)">
                        </el-carousel-item>
                    </el-carousel>
                </div>
                <!--新闻资讯-->
                <div class="news-box">
                    <div class="news-head">
                        <div class="news-title">新闻资讯</div>
                        <div class="news-more" @click="goNewsCenter">
                            更多
                            <el-icon :size="14"><ArrowRight /></el-icon>
                        </div>
                    </div>
                    <div class="news-list">
                        <div class="news-one" v-for="item in newsList.slice(0,7)" :key="item.newsId"
                             @click="viewNews(item)">
                            <div class="news-name">{{item.title}}</div>
                            <div class="news-time">{{timestampToTime(item.releaseTime)}}</div>
                        </div>
                        <el-empty v-if="newsList.length===0" :image-size="100" description="暂无资讯" />
                    </div>
                </div>
            </div>
            <!--第一行-->
            <div class="card-row">
                <!--资源中心 + 教科研（与轮播图同宽）-->
                <div class="card-group group-l">
                    <!--资源中心-->
                    <div class="nav-card" style="flex: 1212;" @click="goCenter('school')">
                        <img src="../../assets/screen/item1.png" alt="资源中心">
                        <div class="hot-area" style="top: 15%; height: 24%;" title="学校文化中心"
                             @click.stop="goCenter('school')"></div>
                        <div class="hot-area" style="top: 42%; height: 23%;" title="教师发展中心"
                             @click.stop="goCenter('teacher')"></div>
                        <div class="hot-area" style="top: 68%; height: 23%;" title="学生成长中心"
                             @click.stop="goCenter('student')"></div>
                    </div>
                    <!--教科研-->
                    <div class="nav-card" style="flex: 1205;" @click="jumpPageHome('/jzedu/tearesearch','homeTeachResearch','1')">
                        <img src="../../assets/screen/item2.png" alt="教科研">
                    </div>
                </div>
                <!--师资培训 + 一体化教研（与新闻资讯同宽）-->
                <div class="card-group group-r">
                    <!--师资培训-->
                    <div class="nav-card" style="flex: 1;" @click="jumpPageHome('/jzedu/train','teacherTrainCenter','2')">
                        <img src="../../assets/screen/item3.png" alt="师资培训">
                    </div>
                    <!--一体化教研-->
                    <div class="nav-card" style="flex: 1;" @click="jumpPageHome('/jzedu/research','homeEduResearch','2')">
                        <img src="../../assets/screen/item4.png" alt="一体化教研">
                    </div>
                </div>
            </div>
            <!--第二行-->
            <div class="card-row">
                <!--名校长工作室 + 名师工作室 + AI教学助手（与轮播图同宽）-->
                <div class="card-group group-l">
                    <!--名校长工作室-->
                    <div class="nav-card" style="flex: 820;" @click="jumpPageHome('/jzedu/rectorstudio','rectorStudioHome','1')">
                        <img src="../../assets/screen/item5.png" alt="名校长工作室">
                    </div>
                    <!--名师工作室-->
                    <div class="nav-card" style="flex: 820;" @click="jumpPageHome('/jzedu/teastudio','teachStudioHome','1')">
                        <img src="../../assets/screen/item6.png" alt="名师工作室">
                    </div>
                    <!--AI教学助手-->
                    <div class="nav-card ai-card" style="flex: 1774;">
                        <img src="../../assets/screen/ai_bg.png" alt="AI+教研中心">
                        <!--顶部标题-->
                        <div class="ai-banner">
                            <span class="ai-banner-text">AI+教研中心</span>
                        </div>
                        <!--超级教研员-->
                        <div class="ai-btn ai-btn-cjjyy" title="超级教研员" @click.stop="comingSoon">
                            <span class="ai-btn-text">超级教研员</span>
                        </div>
                        <!--AI教学助手-->
                        <div class="ai-btn ai-btn-jxzs" title="AI教学助手"
                             @click.stop="jumpPageHome('/jzedu/aiaide','aiAssistant')">
                            <span class="ai-btn-text">AI教学助手</span>
                        </div>
                    </div>
                </div>
                <!--评估评价（与新闻资讯同宽）-->
                <div class="card-group group-r">
                    <div class="nav-card pg-card" style="flex: 1;">
                        <img src="../../assets/screen/item8.png" alt="评估评价">
                        <!--顶部标题-->
                        <div class="pg-banner">
                            <span class="pg-banner-text">评估评价</span>
                        </div>
                        <!--课堂评估-->
                        <div class="pg-btn pg-btn-ktpg" title="课堂评估" @click.stop="teachingToolLink('1')">
                            <span class="pg-btn-text">课堂评估</span>
                        </div>
                        <!--优质均衡-->
                        <div class="pg-btn pg-btn-yzjh" title="优质均衡" @click.stop="comingSoon">
                            <span class="pg-btn-text">优质均衡</span>
                        </div>
                        <!--心理评价-->
                        <div class="pg-btn pg-btn-xlpj" title="心理评价" @click.stop="teachingToolLink('2')">
                            <span class="pg-btn-text">心理评价</span>
                            <img class="pg-icon" src="../../assets/screen/xlpj_icon.png" alt="">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import homeHead from "@/components/homeHead.vue";
import {timestampToTime} from "@/utils/date";
import {listBanner, listNews} from "@/api/admin/welHome";

export default {
    components: {homeHead},
    name: "welHome",
    data() {
        return {
            isLogin:this.$storage.get('isLogin'),
            userInfo : JSON.parse(this.$storage.get("userInfo")),
            classroomUrl:'http://aipowered.k12.seegot.cn/#/login',//课堂分析
            psychicUrl:'https://xlfw.net/',//心理咨询
            timestampToTime,
            bannerList:[],//轮播图
            newsList:[],//新闻资讯
        }
    },
    computed: {},
    watch: {},
    created() {
        this.getBanner();
        this.getNews();
    },
    mounted() {},
    methods: {
        /*轮播图*/
        getBanner(){
            listBanner().then(res => {
                const d = res.data.data;
                this.bannerList = (d && d.list) ? d.list : (d || []);
            })
        },
        /*新闻资讯*/
        getNews(){
            listNews().then(res => {
                const d = res.data.data;
                this.newsList = (d && d.list) ? d.list : (d || []);
            })
        },
        /*查看新闻*/
        viewNews(item){
            let routeUrl = this.$router.resolve({
                path: "/jzedu/news",
                query: { signno: item.newsId, type: '0' }
            });
            window.open(routeUrl.href, '_blank')
        },
        /*查看轮播详情*/
        viewBanner(item){
            let routeUrl = this.$router.resolve({
                path: "/jzedu/news",
                query: { signno: item.bannerId, type: '1' }
            });
            window.open(routeUrl.href, '_blank')
        },
        /*更多新闻*/
        goNewsCenter(){
            this.$router.push({path: '/jzedu/newscenter'});
        },
        userToLogin(){
            this.$router.push("/login")
        },
        /*跳转资源中心并定位到对应中心Tab*/
        goCenter(tab){
            if (this.isLogin){
                this.$store.commit("params/setJumpParams", {activePath:'homeResourceCentre', activeTab: tab});
                this.$router.push({path: '/jzedu/resource'});
            }else {
                this.$confirm("您查看的内容需要登录，是否继续？", "温馨提示", {
                    confirmButtonText: "去登录",
                    cancelButtonText: "取消",
                    type: "success"
                }).then(() => {
                    this.userToLogin()
                }).catch(()=>{})
            }
        },
        jumpPageHome(path,activePath,activeItem){
            if (this.isLogin){
                //参数传递
                this.$store.commit("params/setJumpParams", {activePath:activePath,activeItem: activeItem});
                this.$router.push({path: path,});
            }else {
                this.$confirm("您查看的内容需要登录，是否继续？", "温馨提示", {
                    confirmButtonText: "去登录",
                    cancelButtonText: "取消",
                    type: "success"
                }).then(() => {
                    this.userToLogin()
                }).catch(()=>{})
            }

        },
        /*超级教研员：敬请期待*/
        comingSoon(){
            this.$message({message: '敬请期待', type: 'info'});
        },
        teachingToolLink(type){
            if (this.isLogin){
                if (type==='1'){
                    //课堂评估：跳转站内课堂评估页
                    this.$router.push({ path: '/jzedu/classevaluate' })
                    return
                }
                let toolLink = this.classroomUrl;
                if (type==='2'){
                    toolLink = this.psychicUrl
                }
                window.open(toolLink, '_blank')
            }else {
                this.$confirm("您查看的内容需要登录，是否继续？", "温馨提示", {
                    confirmButtonText: "去登录",
                    cancelButtonText: "取消",
                    type: "success"
                }).then(() => {
                    this.userToLogin()
                }).catch(()=>{})
            }

        },
    }
}
</script>
<!--内联样式-->
<style lang="scss" scoped>
.container {
    width: 100%;
    height: 100vh;
    margin: 0;
    overflow-y: auto;
    overflow-x: hidden;
    /*隐藏滚动条*/
    scrollbar-width: none; /* Firefox */
    -ms-overflow-style: none; /* IE/Edge */
}

/*隐藏滚动条（Webkit）*/
.container::-webkit-scrollbar {
    width: 0;
    height: 0;
    display: none;
}

.home-page {
    min-height: 100vh;
    box-sizing: border-box;
    padding: 110px 40px 20px;
    background: url("../../assets/screen/homeBg.png") no-repeat center center;
    background-size: cover;
}

/*轮播图 + 新闻资讯*/
.top-row {
    display: flex;
    gap: 28px;
    height: 300px;
    /*与下方卡片行保持同一宽度约束，保证各排左右对齐*/
    max-width: unquote("min(1840px, calc((100vh - 158px) * 2.09 + 84px))");
    margin: 0 auto 28px;
}
.banner-box {
    width: calc((100% - 28px) * 2 / 3);
    flex: none;
    min-width: 0;
    border-radius: 16px;
    overflow: hidden;
    background: #ffe7d3;
    box-shadow: 0 4px 16px rgba(255, 127, 46, .08);
}
.banner-box /deep/ .el-carousel,
.banner-box /deep/ .el-carousel__container {
    width: 100%;
    height: 100%;
}
.banner-img {
    width: 100%;
    height: 100%;
    /*完整展示图片，比例不一致时留白处显示容器底色*/
    object-fit: fill;
    cursor: pointer;
}
/*新闻资讯*/
.news-box {
    width: calc((100% - 28px) * 1 / 3);
    flex: none;
    min-width: 0;
    background: #fff;
    border-radius: 16px;
    box-shadow: 0 4px 16px rgba(255, 127, 46, .08);
    box-sizing: border-box;
    padding: 16px 20px;
    display: flex;
    flex-direction: column;
    overflow: hidden;
}
.news-head {
    display: flex;
    align-items: center;
    flex-shrink: 0;
    padding-bottom: 10px;
    border-bottom: 1px solid #f0f0f0;
}
.news-title {
    font-size: 16px;
    font-weight: bold;
    color: #ff7f2e;
}
.news-more {
    display: flex;
    align-items: center;
    gap: 2px;
    margin-left: auto;
    font-size: 13px;
    color: #999;
    cursor: pointer;
}
.news-more:hover {
    color: #ff7f2e;
}
.news-list {
    flex: 1;
    min-height: 0;
    overflow-y: auto;
    /*隐藏滚动条*/
    scrollbar-width: none; /* Firefox */
    -ms-overflow-style: none; /* IE/Edge */
}
/*隐藏滚动条（Webkit）*/
.news-list::-webkit-scrollbar {
    width: 0;
    height: 0;
    display: none;
}
.news-one {
    display: flex;
    align-items: center;
    height: 34px;
    cursor: pointer;
}
.news-name {
    flex: 1;
    min-width: 0;
    font-size: 14px;
    color: #333;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.news-one:hover .news-name {
    color: #ff7f2e;
}
.news-time {
    flex-shrink: 0;
    margin-left: 12px;
    font-size: 13px;
    color: #999;
}

/*卡片行*/
.card-row {
    display: flex;
    gap: 28px;
    width: 100%;
    /*宽度同时受视口高度约束：两行图片高 (W-84)/3.593 与 (W-84)/4.995，
      加 110px 顶距、28px 行距、20px 底距后不超过 100vh*/
    max-width: unquote("min(1840px, calc((100vh - 158px) * 2.09 + 84px))");
    margin: 0 auto 28px;
}

/*卡片分组（组宽与轮播/新闻模块对齐）*/
.card-group {
    display: flex;
    gap: 28px;
    min-width: 0;
}
.card-group.group-l {
    flex: none;
    width: calc((100% - 28px) * 2 / 3);
}
.card-group.group-r {
    flex: none;
    width: calc((100% - 28px) * 1 / 3);
}

.card-row:last-child {
    margin-bottom: 0;
}

.nav-card {
    position: relative;
    min-width: 0;
    cursor: pointer;
    transition: transform .2s ease;

    img {
        width: 100%;
        display: block;
    }
}

.nav-card:hover {
    transform: translateY(-4px);
}

/*预合成卡片内的子项热区*/
.hot-area {
    position: absolute;
    left: 6%;
    width: 88%;
    cursor: pointer;
}

/*AI教学助手卡片*/
.ai-card {
    /*背景图不重复放大，悬停位移由按钮自身承担*/
    &:hover {
        transform: none;
    }

    /*顶部黄色标题条（背景图 + 文字，同评估评价卡片）*/
    .ai-banner {
        position: absolute;
        top: 0;
        left: 25%;
        width: 50%;
        pointer-events: none;
        display: flex;
        align-items: center;
        justify-content: center;
        background: url("../../assets/screen/ai_word_bg.png") no-repeat center / 100% 100%;
        /*按背景图原始比例撑开高度，避免标题条被压扁*/
        aspect-ratio: 840 / 180;

        .ai-banner-text {
            font-size: 1.4vw;
            font-weight: 700;
            color: #8a5a24;
            letter-spacing: 1px;
            white-space: nowrap;
            font-family: JiangCheng-700,sans-serif;;
        }
    }

    /*功能入口按钮（背景图 + 文字，嵌套以提升权重，覆盖 .nav-card img 的 width:100%）*/
    .ai-btn {
        position: absolute;
        left: 5%;
        width: 42%;
        /*按背景图原始比例撑开高度*/
        aspect-ratio: 750 / 300;
        display: flex;
        align-items: center;
        justify-content: center;
        background: no-repeat center / 100% 100%;
        cursor: pointer;
        transition: transform .2s ease;

        &:hover {
            transform: scale(1.03);
        }

        .ai-btn-text {
            font-size: 1.5vw;
            font-weight: 700;
            letter-spacing: 2px;
            white-space: nowrap;
            font-family: JiangCheng-700,sans-serif;;
        }
    }
    .ai-btn-cjjyy {
        top: 24%;
        background-image: url("../../assets/screen/cjjyy.png");
        color: #c2571a;
    }
    .ai-btn-jxzs {
        top: 58%;
        background-image: url("../../assets/screen/ai_jxzs.png");
        color: #8a4a1a;
    }
}

/*评估评价卡片*/
.pg-card {
    /*背景图不重复放大，悬停位移由按钮自身承担*/
    &:hover {
        transform: none;
    }

    /*顶部黄色标题条（背景图 + 文字，同 AI 教学助手卡片）*/
    .pg-banner {
        position: absolute;
        top: 0;
        left: 25%;
        width: 50%;
        pointer-events: none;
        display: flex;
        align-items: center;
        justify-content: center;
        background: url("../../assets/screen/ai_word_bg.png") no-repeat center / 100% 100%;
        /*按背景图原始比例撑开高度，避免标题条被压扁*/
        aspect-ratio: 840 / 180;

        .pg-banner-text {
            font-size: 1.4vw;
            font-weight: 700;
            color: #8a5a24;
            letter-spacing: 1px;
            white-space: nowrap;
            font-family: JiangCheng-700,sans-serif;
        }
    }

    /*功能入口按钮（背景图 + 文字）*/
    .pg-btn {
        position: absolute;
        left: 6%;
        width: 88%;
        /*按背景图原始比例撑开高度*/
        aspect-ratio: 520 / 72;
        display: flex;
        align-items: center;
        background: no-repeat center / 100% 100%;
        /*背景图为直角，裁出圆角*/
        border-radius: 0.7vw;
        cursor: pointer;
        transition: transform .2s ease;

        &:hover {
            transform: scale(1.03);
        }

        .pg-btn-text {
            padding-left: 12%;
            font-size: 1.4vw;
            font-weight: 700;
            letter-spacing: 2px;
            white-space: nowrap;
            font-family: JiangCheng-700,sans-serif;
        }

        /*心理评价按钮右侧图标（嵌套以提升权重，覆盖 .nav-card img 的 width:100%）*/
        .pg-icon {
            position: absolute;
            right: 10%;
            top: 50%;
            width: 14%;
            transform: translateY(-50%);
        }
    }
    .pg-btn-ktpg {
        top: 23%;
        background-image: url("../../assets/screen/ktpg_bg.png");
        color: #d95f0f;
    }
    .pg-btn-yzjh {
        top: 46%;
        background-image: url("../../assets/screen/yzjh_bg.png");
        color: #b06a1c;
    }
    .pg-btn-xlpj {
        top: 69%;
        background-image: url("../../assets/screen/xlpj_bg.png");
        color: #c2571a;
    }
}
</style>
